"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate2keysLabel = translate2keysLabel;
exports.translateObjectLabel = translateObjectLabel;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
var _toUpper2 = _interopRequireDefault(require("lodash/toUpper"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
/**
 * translate object label
 * @param {{ en: String, ar: String }} label
 * @param {String} language
 * @return {String} translated label
 */
function translateObjectLabel(label, language) {
  var translatedLabel = (0, _get2["default"])(label, language);
  return translatedLabel ? translatedLabel : (0, _get2["default"])(label, _constants.LANGUAGE.EN, '');
}

/**
 * translate 2 keys label
 * @description
 * it translates 2 keys label ex: nameEn, nameAr
 * @param {Object} source the actual object that contains the key
 * @param {String} key ex: name
 * @param {String} language
 * @param {Boolean} isUpperCase
 * @return {String} translated label
 */
function translate2keysLabel(source, key, language) {
  var translatedLabel = (0, _get2["default"])(source, "".concat(key).concat((0, _capitalize2["default"])(language)), false);
  if (!translatedLabel) {
    translatedLabel = (0, _get2["default"])(source, "".concat(key).concat((0, _toUpper2["default"])(language)), false);
  }
  if (translatedLabel) {
    return translatedLabel;
  }
  var defaultUntranslatedLabel = (0, _get2["default"])(source, "".concat(key).concat((0, _capitalize2["default"])(_constants.LANGUAGE.EN)), '');
  if (defaultUntranslatedLabel) {
    return defaultUntranslatedLabel;
  }
  return (0, _get2["default"])(source, "".concat(key).concat((0, _toUpper2["default"])(_constants.LANGUAGE.EN)), '');
}